module.exports = __webpack_public_path__ + "static/media/tmc-header-logo.a73cecea.svg";